export const TYPE_BY_PROPERTY = "BY_PROPERTY";
export const TYPE_PRORATA = "PRORATA";
export const TYPE_PERCENTAGE = "PERCENTAGE";

export const TYPES = [
  TYPE_BY_PROPERTY,
  TYPE_PRORATA,
  TYPE_PERCENTAGE,
];